module.exports = __webpack_public_path__ + "media/header-background.6bba0587.mp4";